module.exports = __webpack_public_path__ + "Frame393-1c39f847.webp";